/**
* Receives an array of reports; change somes fields (datatype, formats, etc)
* @param arr:array of report objects
* @returns {array} : new array with format reports
*/
function formatReports(arr) {
    return arr.map(x => {
        x.first_date = x.first_date ? new Date(x.first_date).toUTCString() : null;
        x.last_date = x.last_date ? new Date(x.last_date).toUTCString() : null;
        x.date = x.date ? new Date(x.date).toUTCString() : null;
        return x;
    });
}

function debounce(callback, wait) {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

export { formatReports, debounce }
